/*
  RS search (2026-09-24)

  1. MUTCD code matching. Shopify's search reads a code like W1-2L as one whole word,
     so typing "w1-2" never finds the Left or Right Curve sign. This script loads the
     store's code list once (sections/rs-search-data.liquid, cached in the browser for
     6 hours) and gives code searches the same layout as word searches, focused on codes:
       - dropdown: exact code matches on top of the product column; "MUTCD codes" and
         "Categories" lists in the left column (in place of Shopify's word suggestions,
         which turn codes into "w1 2l")
       - search results page: code matches above the product grid (skipped when
         Shopify's own results already lead with them) and category tiles built from
         the matching signs.
     Code rules: W1-2 finds W1-2, W1-2L, W1-2R first, then other W1-2 variants
     (W1-2aL...). W1 alone lists the whole W1 series. Spaces, dashes and case do not
     matter ("w1 2", "W1-2", "w12").

  2. Dropdown tune-up: asks Shopify for up to 8 of each result type (Dawn asked for 10
     results total), Escape closes the dropdown and keeps the typed words.
*/
(function () {
  if (window.rsSearch) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CACHE_KEY = 'rsCodeIndex:v2';
  var CACHE_MS = 6 * 60 * 60 * 1000;
  var DROPDOWN_MAX = 6;
  var DROPDOWN_CODES = 6;
  var DROPDOWN_CATS = 5;
  var RESULTS_MAX = 8;
  var RESULTS_MAX_PHONE = 4;
  var RESULTS_CATS = 6;
  var TITLE_CODE = /\b([A-Z]{1,3}\d{1,2}-\d{1,3}[A-Za-z]{0,4})\b/;
  // Store-wide, color and shape categories: never offered as "related"
  var HUB_CATS = {
    all: 1, frontpage: 1, 'best-sellers': 1, 'mutcd-signs': 1, 'signs-by-colors': 1, 'signs-by-shape': 1,
    'diamond-road-signs': 1, 'square-road-signs': 1, 'rectangle-road-signs': 1,
    'red-signs': 1, 'white-signs': 1, 'yellow-signs': 1, 'yellow-green-signs': 1
  };

  /* ---------- code parsing ---------- */

  function norm(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[\u2010-\u2015\u2212]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function splitCode(code) {
    var m = /^([A-Z]{1,3}\d{1,2})-(\d{1,3})([A-Z]{0,4})$/.exec(norm(code).replace(/ /g, ''));
    return m ? { series: m[1], num: m[2], suf: m[3] } : null;
  }

  // Turns what the shopper typed into code specs. Returns [] for normal words.
  function parseQuery(query) {
    var s = norm(query).replace(/"/g, '').replace(/^MUTCD\s*/, '');
    var specs = [];
    var m;
    if (!s || !/[A-Z]/.test(s) || !/\d/.test(s)) return specs;

    // "W1", "W1-": the whole series
    if ((m = /^([A-Z]{1,3}\d{1,2}) ?-?$/.exec(s))) {
      specs.push({ series: m[1], num: null, suf: '' });
    }

    // "W1-2", "W1 2L", "stop sign R1-1"
    var re = /(?:^|[^A-Z0-9])([A-Z]{1,3}\d{1,2}) ?[-. ] ?(\d{1,3})([A-Z]{0,4})(?=$|[^A-Z0-9])/g;
    while ((m = re.exec(s))) {
      specs.push({ series: m[1], num: m[2], suf: m[3] });
      re.lastIndex = m.index + m[0].length;
    }

    // "W12", "W12L", "R11": no separator, try each split point
    if ((m = /^([A-Z]{1,3})(\d{2,5})([A-Z]{0,4})$/.exec(s))) {
      for (var i = 1; i <= 2; i++) {
        var head = m[2].slice(0, i);
        var tail = m[2].slice(i);
        if (tail && tail.length <= 3) specs.push({ series: m[1] + head, num: tail, suf: m[3], glued: true });
      }
    }
    return specs;
  }

  function specLabel(spec) {
    return spec.num == null ? spec.series : spec.series + '-' + spec.num + spec.suf;
  }

  // rank 0 = exact code, 1 = same code + L/R/D, 2 = other variants, 3 = same series.
  // A code typed without its dash ("w11") reads as a series first (W11-1, W11-2...),
  // then as W1-1 (rank +4).
  function findMatches(entries, specs) {
    var best = {};
    specs.forEach(function (spec, specIndex) {
      entries.forEach(function (e) {
        var p = e.parts;
        if (!p || p.series !== spec.series) return;
        var rank;
        if (spec.num == null) {
          rank = 3;
        } else {
          if (p.num !== spec.num) return;
          if (p.suf === spec.suf) rank = 0;
          else if (p.suf.indexOf(spec.suf) === 0)
            rank = p.suf.length === spec.suf.length + 1 && /[LRD]$/.test(p.suf) ? 1 : 2;
          else return;
          if (spec.glued) rank += 4;
        }
        var old = best[e.handle];
        if (!old || rank < old.rank) best[e.handle] = { e: e, rank: rank, spec: specIndex };
      });
    });
    var list = Object.keys(best).map(function (k) {
      return best[k];
    });
    list.sort(function (a, b) {
      return (
        a.rank - b.rank ||
        +a.e.parts.num - +b.e.parts.num ||
        a.e.parts.suf.length - b.e.parts.suf.length ||
        (a.e.parts.suf < b.e.parts.suf ? -1 : a.e.parts.suf > b.e.parts.suf ? 1 : 0) ||
        a.e.title.length - b.e.title.length ||
        (a.e.title < b.e.title ? -1 : 1)
      );
    });
    var label = '';
    if (list.length) {
      var top = list[0];
      label = top.rank === 0 ? top.e.code : specLabel(specs[top.spec]);
    }
    return { list: list, label: label, series: list.length > 0 && list[0].rank === 3 };
  }


  /* ---------- code list ---------- */

  var indexPromise = null;

  function toIndex(rows, cats) {
    var entries = rows.map(function (r) {
      var code = r[0] || '';
      if (!code) {
        var t = TITLE_CODE.exec(r[1] || '');
        if (t) code = t[1];
      }
      return {
        code: code,
        parts: code ? splitCode(code) : null,
        title: r[1] || '',
        handle: r[2],
        url: ROOT + 'products/' + r[2],
        img: r[3] || '',
        price: r[4] || 0,
        varies: r[5] === 1,
        cats: r[6] || []
      };
    });
    var catMap = {};
    (cats || []).forEach(function (c) {
      catMap[c[0]] = { handle: c[0], title: c[1], count: c[2], img: c[3] || '', url: ROOT + 'collections/' + c[0] };
    });
    return { entries: entries, cats: catMap };
  }

  function fetchIndexPage(page) {
    return fetch(ROOT + 'collections/all?section_id=rs-search-data&page=' + page, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('code list ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-rs-codes]');
        if (!el) throw new Error('code list missing');
        var cats = doc.querySelector('[data-rs-cats]');
        return {
          pages: parseInt(el.getAttribute('data-pages'), 10) || 1,
          rows: JSON.parse(el.textContent),
          cats: cats ? JSON.parse(cats.textContent) : null
        };
      });
  }

  // Resolves to { entries: [...products], cats: { handle: category } }
  function getIndex() {
    if (indexPromise) return indexPromise;
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (cached && Date.now() - cached.t < CACHE_MS && cached.rows && cached.rows.length) {
        indexPromise = Promise.resolve(toIndex(cached.rows, cached.cats));
        return indexPromise;
      }
    } catch (e) {}
    indexPromise = fetchIndexPage(1)
      .then(function (first) {
        var more = [];
        for (var p = 2; p <= Math.min(first.pages, 8); p++) more.push(fetchIndexPage(p));
        return Promise.all(more).then(function (rest) {
          var rows = first.rows;
          rest.forEach(function (x) {
            rows = rows.concat(x.rows);
          });
          try {
            localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), rows: rows, cats: first.cats }));
          } catch (e) {}
          return toIndex(rows, first.cats);
        });
      })
      .catch(function (err) {
        indexPromise = null;
        throw err;
      });
    return indexPromise;
  }

  /* ---------- grouping for the code layout ---------- */

  // A short name for a group of signs sharing one code: the words their titles start
  // with ("Speed Limit" for every R2-1), taken from the largest group of alike titles.
  function codeName(list) {
    var words = list.map(function (e) {
      return e.title
        .replace(e.code, '')
        .replace(/^(official\s+)?mutcd\s+/i, '')
        .replace(/[\s\-\u2013(]+$/, '')
        .trim()
        .split(/\s+/);
    });
    var byFirst = {};
    words.forEach(function (w) {
      (byFirst[w[0]] = byFirst[w[0]] || []).push(w);
    });
    var group = Object.keys(byFirst)
      .map(function (k) {
        return byFirst[k];
      })
      .sort(function (a, b) {
        return b.length - a.length;
      })[0];
    var name = group[0];
    if (group.length > 1) {
      var n = 0;
      while (
        n < group[0].length &&
        group.every(function (w) {
          return w[n] && w[n].toLowerCase() === group[0][n].toLowerCase();
        })
      )
        n++;
      name = group[0].slice(0, n);
    }
    name = name
      .join(' ')
      .replace(/\b(signs?|plaque)\b/gi, '')
      .replace(/\(\s*\)/g, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/[\s\-\u2013(]+$/, '')
      .trim();
    return name || list[0].title;
  }

  // Distinct codes in match order: [{ code, name, count }]
  function codeGroups(matches) {
    var order = [];
    var byCode = {};
    matches.forEach(function (m) {
      var key = m.e.code.toUpperCase();
      if (!byCode[key]) {
        byCode[key] = { code: m.e.code, list: [] };
        order.push(key);
      }
      byCode[key].list.push(m.e);
    });
    return order.map(function (k) {
      var g = byCode[k];
      return { code: g.code, name: codeName(g.list), count: g.list.length };
    });
  }

  // Categories holding the biggest share of the matching signs (same rule as the
  // "related categories" row on the search page)
  function relatedCats(matches, catMap, max) {
    var hits = {};
    matches.forEach(function (m) {
      m.e.cats.forEach(function (h) {
        if (!HUB_CATS[h] && catMap[h]) hits[h] = (hits[h] || 0) + 1;
      });
    });
    return Object.keys(hits)
      .map(function (h) {
        return { cat: catMap[h], score: (hits[h] * 10000) / (catMap[h].count + 20) };
      })
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .slice(0, max)
      .map(function (x) {
        return x.cat;
      });
  }

  /* ---------- small helpers ---------- */

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function priceText(e) {
    return (e.varies ? 'From ' : '') + money(e.price);
  }

  function searchUrl(q) {
    return ROOT + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }

  function handleFromHref(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function codeTitle(found) {
    return found.series ? 'MUTCD ' + esc(found.label) + ' series' : 'MUTCD code ' + esc(found.label);
  }

  /* ---------- dropdown ---------- */

  function sideGroup(key, heading, items) {
    var id = 'predictive-search-' + key;
    var html =
      '<div class="rs-ps__group" data-rs-own="' +
      key +
      '"><h2 id="' +
      id +
      '" class="rs-ps__heading">' +
      heading +
      '</h2><ul class="rs-ps__list list-unstyled" role="group" aria-labelledby="' +
      id +
      '">';
    items.forEach(function (it, i) {
      html +=
        '<li id="predictive-search-option-' +
        key +
        '-' +
        (i + 1) +
        '" class="predictive-search__list-item rs-ps__li" role="option" aria-selected="false"><a href="' +
        esc(it.url) +
        '" class="predictive-search__item rs-ps__text" tabindex="-1">' +
        it.label +
        '<span class="rs-ps__count">' +
        it.count +
        '</span></a></li>';
    });
    return html + '</ul></div>';
  }

  function enhanceDropdown(ps) {
    var query = ps.getQuery();
    var specs = parseQuery(query);
    if (!specs.length) return;

    getIndex()
      .then(function (index) {
        if (ps.getQuery() !== query) return;
        var box = ps.querySelector('[data-rs-codes]');
        if (!box || box.getAttribute('data-rs-for') === query) return;
        var found = findMatches(index.entries, specs);
        if (!found.list.length) return;

        // Product column: exact code matches first
        var shown = found.list.slice(0, DROPDOWN_MAX);
        var html =
          '<h2 id="predictive-search-codes" class="rs-ps__heading">' +
          codeTitle(found) +
          ' <span class="rs-ps__count">&middot; ' +
          found.list.length +
          (found.list.length === 1 ? ' sign' : ' signs') +
          '</span></h2><ul class="rs-ps__list list-unstyled" role="group" aria-labelledby="predictive-search-codes">';
        shown.forEach(function (m, i) {
          var e = m.e;
          html +=
            '<li id="predictive-search-option-code-' +
            (i + 1) +
            '" class="predictive-search__list-item rs-ps__li" role="option" aria-selected="false" data-handle="' +
            esc(e.handle) +
            '"><a href="' +
            esc(e.url) +
            '" class="predictive-search__item rs-ps__prod" tabindex="-1"><span class="rs-ps__thumb">' +
            (e.img ? '<img src="' + esc(e.img) + '" alt="" width="56" height="56">' : '') +
            '</span><span class="rs-ps__ptext"><span class="rs-ps__ptitle predictive-search__item-heading">' +
            esc(e.title) +
            '</span><span class="rs-ps__pmeta"><span class="rs-code">' +
            esc(e.code) +
            '</span><span class="rs-ps__price">' +
            priceText(e) +
            '</span></span></span></a></li>';
        });
        html += '</ul>';
        if (found.list.length > shown.length) {
          html +=
            '<a class="rs-ps__more" href="' +
            esc(searchUrl(found.label)) +
            '">See all ' +
            found.list.length +
            ' ' +
            esc(found.label) +
            ' signs</a>';
        }
        box.innerHTML = html;
        box.setAttribute('data-rs-for', query);

        // Drop Shopify's copies of the same products, relabel what is left
        var codeHandles = {};
        found.list.forEach(function (m) {
          codeHandles[m.e.handle] = 1;
        });
        var group = ps.querySelector('[data-rs-products]');
        if (group) {
          var left = 0;
          Array.prototype.forEach.call(group.querySelectorAll('li[data-handle]'), function (li) {
            if (codeHandles[li.getAttribute('data-handle')]) li.remove();
            else left++;
          });
          if (!left) group.hidden = true;
          var h = group.querySelector('[data-rs-products-heading]');
          if (h) h.textContent = 'Related products';
        }

        // Left column: MUTCD codes + categories of the matching signs, then Shopify's guides
        var side = ps.querySelector('[data-rs-side]');
        var wrap = ps.querySelector('#predictive-search-results-groups-wrapper');
        if (side) {
          Array.prototype.forEach.call(side.querySelectorAll('[data-rs-suggestions], [data-rs-categories]'), function (g) {
            g.hidden = true;
          });
          var codes = codeGroups(found.list)
            .slice(0, DROPDOWN_CODES)
            .map(function (g) {
              return {
                url: searchUrl(g.code),
                label:
                  '<span class="rs-ps__codeline"><span class="rs-code">' +
                  esc(g.code) +
                  '</span><span class="predictive-search__item-heading">' +
                  esc(g.name) +
                  '</span></span>',
                count: g.count
              };
            });
          var cats = relatedCats(found.list, index.cats, DROPDOWN_CATS).map(function (c) {
            return {
              url: c.url,
              label: '<span class="predictive-search__item-heading">' + esc(c.title) + '</span>',
              count: c.count
            };
          });
          var own = sideGroup('mutcd', 'MUTCD codes', codes) + (cats.length ? sideGroup('rscats', 'Categories', cats) : '');
          Array.prototype.forEach.call(side.querySelectorAll('[data-rs-own]'), function (g) {
            g.remove();
          });
          side.insertAdjacentHTML('afterbegin', own);
          side.hidden = false;
        }
        if (wrap) wrap.classList.remove('rs-ps--no-side');
        if (wrap) wrap.classList.add('rs-ps--has-codes');
        if (!ps.isOpen && document.activeElement && ps.contains(document.activeElement)) ps.open();
      })
      .catch(function () {});
  }

  function patchPredictiveSearch(PS) {
    var proto = PS.prototype;
    if (proto.__rsPatched) return;
    proto.__rsPatched = true;

    // Same as Dawn's, plus more results per type and the MUTCD code block
    proto.getSearchResults = function (searchTerm) {
      var self = this;
      var queryKey = searchTerm.replace(' ', '-').toLowerCase();
      this.setLiveRegionLoadingState();

      if (parseQuery(searchTerm).length) getIndex().catch(function () {});

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        var cachedDeferred = this.dispatchSearchUpdateEvent(searchTerm);
        if (cachedDeferred) cachedDeferred.resolve({ totalCount: this.getTotalResultCount() });
        return;
      }

      var searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);

      var url =
        routes.predictive_search_url +
        '?q=' +
        encodeURIComponent(searchTerm) +
        '&section_id=predictive-search' +
        '&resources%5Btype%5D=product%2Ccollection%2Cquery%2Carticle%2Cpage' +
        '&resources%5Blimit%5D=8&resources%5Blimit_scope%5D=each' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last';

      fetch(url, { signal: this.abortController.signal })
        .then(function (response) {
          if (!response.ok) {
            self.close();
            throw new Error(response.status);
          }
          return response.text();
        })
        .then(function (text) {
          var markup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;
          self.allPredictiveSearchInstances.forEach(function (instance) {
            instance.cachedResults[queryKey] = markup;
          });
          if (self.getQuery() !== searchTerm) return;
          self.renderSearchResults(markup);
          if (searchDeferred) searchDeferred.resolve({ totalCount: self.getTotalResultCount() });
        })
        .catch(function (error) {
          if (searchDeferred) searchDeferred.reject(error);
          if (error && error.name === 'AbortError') return;
          self.close();
        });
    };

    var render = proto.renderSearchResults;
    proto.renderSearchResults = function (markup) {
      render.call(this, markup);
      enhanceDropdown(this);
    };

    // Dawn builds a RegExp from the typed words; "(" or "+" would throw and stop the dropdown
    proto.updateSearchForTerm = function (previousTerm, newTerm) {
      var el = this.querySelector('[data-predictive-search-search-for-text]');
      if (!el || !previousTerm) return;
      var text = el.innerText;
      if (text.split(previousTerm).length === 2) el.innerText = text.replace(previousTerm, newTerm);
    };
  }


  if (window.customElements) {
    customElements.whenDefined('predictive-search').then(function () {
      patchPredictiveSearch(customElements.get('predictive-search'));
    });
  }

  // Escape closes the dropdown and keeps the typed words (the browser would wipe them)
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var ps = event.target && event.target.closest && event.target.closest('predictive-search');
    if (!ps || !ps.isOpen) return;
    event.preventDefault();
    ps.close();
    if (ps.input) ps.input.blur();
  });

  // Start loading the code list when the shopper clicks into the search bar, so it is
  // ready by the time a code is typed (one small download, then cached for 6 hours)
  document.addEventListener('focusin', function (event) {
    var t = event.target;
    if (t && t.name === 'q' && t.type === 'search') getIndex().catch(function () {});
  });

  /* ---------- search results page ---------- */

  function catTile(c) {
    return (
      '<a href="' +
      esc(c.url) +
      '" class="b2b-subcard"><div class="b2b-subcard-img-wrap">' +
      (c.img
        ? '<img src="' + esc(c.img) + '" alt="" width="300" height="300" loading="lazy" class="b2b-subcard-img">'
        : '') +
      '</div><span class="b2b-subcard-title">' +
      esc(c.title) +
      '</span></a>'
    );
  }

  function resultsPage() {
    var codesBox = document.querySelector('[data-rs-results-codes]');
    var catsRow = document.querySelector('[data-rs-results-cats]');
    if (!codesBox) return;
    // Category row: code searches wait for the code list (row starts hidden)
    var catsWaiting = catsRow && catsRow.hasAttribute('data-rs-code-like');
    function showServerCats() {
      if (catsWaiting && catsRow.querySelector('.b2b-subcard')) catsRow.hidden = false;
    }
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q') || '';
    var firstPage = (params.get('page') || '1') === '1';
    var specs = parseQuery(q);
    if (!q || !firstPage || !specs.length) {
      showServerCats();
      return;
    }

    getIndex()
      .then(function (index) {
        var found = findMatches(index.entries, specs);
        if (!found.list.length) {
          showServerCats();
          return;
        }

        if (catsWaiting) {
          var cats = relatedCats(found.list, index.cats, RESULTS_CATS);
          if (cats.length > 1) {
            var scroll = catsRow.querySelector('.b2b-subcollections-scroll');
            if (scroll) scroll.innerHTML = cats.map(catTile).join('');
            catsRow.hidden = false;
          } else {
            showServerCats();
          }
        }

        // Skip the code block when Shopify's grid already leads with exactly these signs
        var grid = [];
        Array.prototype.forEach.call(document.querySelectorAll('#product-grid a[href*="/products/"]'), function (a) {
          var h = handleFromHref(a.getAttribute('href'));
          if (h && grid.indexOf(h) === -1) grid.push(h);
        });
        var need = found.list.map(function (m) {
          return m.e.handle;
        });
        var lead = grid.slice(0, need.length);
        var alreadyFirst =
          need.length <= grid.length &&
          need.every(function (h) {
            return lead.indexOf(h) !== -1;
          });
        if (alreadyFirst) return;

        var html =
          '<div class="rs-sr-codes__head"><h2 class="rs-sr-codes__title">' +
          codeTitle(found) +
          '</h2><span class="rs-sr-codes__count">' +
          found.list.length +
          (found.list.length === 1 ? ' matching sign' : ' matching signs') +
          '</span></div><ul class="rs-sr-codes__grid list-unstyled" role="list">';
        found.list.forEach(function (m, i) {
          var e = m.e;
          html +=
            '<li class="rs-sr-code' +
            (i >= RESULTS_MAX ? ' rs-sr-code--extra' : i >= RESULTS_MAX_PHONE ? ' rs-sr-code--phone-extra' : '') +
            '"><a href="' +
            esc(e.url) +
            '" class="rs-sr-code__link"><span class="rs-sr-code__img">' +
            (e.img ? '<img src="' + esc(e.img) + '" alt="" width="80" height="80" loading="lazy">' : '') +
            '</span><span class="rs-sr-code__text"><span class="rs-sr-code__title">' +
            esc(e.title) +
            '</span><span class="rs-sr-code__meta"><span class="rs-code">' +
            esc(e.code) +
            '</span><span class="rs-sr-code__price">' +
            priceText(e) +
            '</span></span></span></a></li>';
        });
        html += '</ul>';
        if (found.list.length > RESULTS_MAX_PHONE) {
          html +=
            '<button type="button" class="button button--secondary rs-sr-codes__more' +
            (found.list.length > RESULTS_MAX ? '' : ' rs-sr-codes__more--phone') +
            '" data-rs-codes-more>Show all ' +
            found.list.length +
            ' signs</button>';
        }
        codesBox.innerHTML = html;
        codesBox.hidden = false;
        var more = codesBox.querySelector('[data-rs-codes-more]');
        if (more) {
          more.addEventListener('click', function () {
            codesBox.classList.add('rs-sr-codes--all');
            more.remove();
          });
        }
        var none = document.querySelector('[data-rs-noresults]');
        if (none) none.hidden = true;
      })
      .catch(showServerCats);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', resultsPage);
  else resultsPage();

  window.rsSearch = {
    parseQuery: parseQuery,
    findMatches: findMatches,
    getIndex: getIndex,
    toIndex: toIndex,
    codeGroups: codeGroups,
    relatedCats: relatedCats
  };
})();
